export const DMS_MODULE = 'NoveVozy';
